import { AlertTriangle, Compass, MapPinOff } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [MapPinOff, AlertTriangle, Compass];

export default function Problem() {
  const { t } = useI18n();
  const cards = t("problem.cards");

  return (
    <section className="section bg-white" data-testid="section-problem">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow" data-testid="problem-eyebrow">{t("problem.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("problem.title")}</h2>
          <p className="lede mt-5">{t("problem.lede")}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {cards.map((c, i) => {
            const Icon = ICONS[i] || AlertTriangle;
            return (
              <div
                key={i}
                className="card-soft p-7 hover:shadow-lift transition-transform duration-200 hover:-translate-y-1"
                data-testid={`problem-card-${i}`}
              >
                <div className="h-11 w-11 rounded-xl bg-brand-redSoft text-brand-red flex items-center justify-center">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 text-lg font-bold text-brand-charcoal">{c.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-brand-charcoal/70">{c.d}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 rounded-3xl border border-brand-line bg-brand-sand p-8 md:p-10 relative overflow-hidden">
          <div className="absolute -top-6 start-6 text-6xl font-extrabold text-brand-green/20" aria-hidden="true">&ldquo;</div>
          <p className="relative text-xl md:text-2xl font-semibold text-brand-charcoal leading-snug max-w-4xl">
            {t("problem.quote")}
          </p>
        </div>
      </div>
    </section>
  );
}
